export const inputTypeValue = {
  NUMERO_TIPO_INT: 'int',
  NUMERO_TIPO_FLOAT: 'float',
  NUMERO_TIPO_DOUBLE: 'double',
  TEXTO: 'string',
  CARACTER: 'char',
  BOOLEAN_DATO_LOGICO: 'bool'
}
